import { gql, useQuery } from '@moonpig/web-core-graphql'
import { isLoggedIn } from '@moonpig/web-core-auth'
import { getBrowserCookies } from '@moonpig/web-core-browser-storage'
import {
  UseCustomerFirstNameQuery,
  UseCustomerFirstNameQueryVariables,
} from './__generated__/useCustomerFirstName'

export const useCustomerFirstNameQuery = gql`
  query UseCustomerFirstNameQuery($isAuthenticated: Boolean!) {
    me @include(if: $isAuthenticated) {
      customer {
        firstName
      }
    }
  }
`

export const useCustomerFirstName = (): string | undefined => {
  const cookies = getBrowserCookies()
  const isAuthenticated = isLoggedIn(cookies)

  const { data, error } = useQuery<
    UseCustomerFirstNameQuery,
    UseCustomerFirstNameQueryVariables
  >(useCustomerFirstNameQuery, {
    variables: { isAuthenticated },
    ssr: false,
    skip: !isAuthenticated,
  })

  if (error) return undefined

  const firstName = data?.me?.customer?.firstName?.trim()

  return firstName || undefined
}
